import { ThemeOptions } from '@mui/material/styles';

import { enableMobileWebviewUi } from '../../hooks/useGetFeatureFlags';
import { clubCardStyleOverrides, CLUB_ACCENT_GRADIENT } from './cardStyles';

export const mwgColors = {
  primary: '#003087',
  primaryShade: '#002a77',
  primaryTint: '#1a4593',
  primaryContrast: '#ffffff',
  backgroundContent: '#f5f6f7',
} as const;

const mwgThemeOptions: ThemeOptions = {
  palette: {
    primary: {
      main: mwgColors.primary,
      dark: mwgColors.primaryShade,
      light: mwgColors.primaryTint,
      contrastText: mwgColors.primaryContrast,
    },
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: clubCardStyleOverrides({
          accentImage: `linear-gradient(${mwgColors.primary}, ${mwgColors.primary})`,
          legacyAccent: CLUB_ACCENT_GRADIENT,
          border: '1.5px solid #d1d3d4',
        }),
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: mwgColors.primary,
          '&:focus': {
            color: mwgColors.primaryShade,
            outline: `solid 2px ${mwgColors.primaryShade}`,
          },
          '&:hover': { color: mwgColors.primaryShade },
        },
      },
    },
    MuiButton: {
      ...(enableMobileWebviewUi && {
        styleOverrides: { root: { borderRadius: '30px' } },
      }),
      variants: [
        {
          props: { variant: 'contained' },
          style: {
            backgroundColor: mwgColors.primary,
            '&:focus': {
              border: `1px solid ${mwgColors.primaryShade}`,
              backgroundColor: mwgColors.primaryShade,
              outline: `solid 2px ${mwgColors.primaryShade}`,
              outlineOffset: '1px',
            },
            '&:hover': { backgroundColor: mwgColors.primaryShade },
          },
        },
        {
          props: { variant: 'text' },
          style: {
            '&:focus': {
              color: mwgColors.primaryShade,
              outline: `solid 2px ${mwgColors.primaryShade}`,
              outlineOffset: '1px',
            },
          },
        },
      ],
    },
    MuiSwitch: {
      styleOverrides: {
        root: {
          '.MuiSwitch-switchBase.Mui-checked:hover': {
            backgroundColor: `${mwgColors.primary}1A`,
          },
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: { '&:focus': { outline: `solid 2px ${mwgColors.primaryShade}` } },
      },
    },
  },
};

export default mwgThemeOptions;
